import { css, keyframes } from '@emotion/react';

import StarIcon from '@mui/icons-material/Star';

const bounce = keyframes`
  from, 10%, 26.5%, 40%, 50%, to {
    transform: translate3d(0,0,0);
  }

  20%, 21.5% {
    transform: translate3d(0, -30px, 0);
  }

  35% {
    transform: translate3d(0, -15px, 0);
  }

  45% {
    transform: translate3d(0,-4px,0);
  }
`;

export const AnimatedStar = () => (
  <StarIcon
    css={css`
      animation: ${bounce} 2s ease infinite;
    `}
  />
);
